import { useI18n } from '@cascade/react/i18n';
import { Button, Text } from '@cascade/ui-library';
import classes from './TermsDeclined.module.scss';
import type { TTermsDeclinedProps } from './TermsDeclined.types.ts';

export const TermsDeclined = ({ onBack }: TTermsDeclinedProps) => {
  const { translate } = useI18n();

  return (
    <div className={classes['terms-declined']}>
      <div className={classes.paragraphs}>
        <Text
          type='body-2'
          content={translate('signIn.termsDeclined.declined')}
        />
        <Text
          type='body-2'
          content={translate('signIn.termsDeclined.support')}
        />
        <Text
          type='body-2'
          content={translate('signIn.termsDeclined.thanks')}
        />
      </div>
      <Button
        variant='secondary'
        label={translate('signIn.termsDeclined.back')}
        onClick={onBack}
      />
    </div>
  );
};
